import { CARD_HEIGHT, CARD_WIDTH, Game } from '@phaser/scenes/Game';
import { EnemyObject } from '@phaser/objects/Enemy.object';
import { defaultText } from '@phaser/helpers/Text';

export class LevelBehavior {
  private _scene: Game = Game.current;
  private _level: number;

  constructor(private _enemy: EnemyObject) {
    this._level = this._enemy.data.enemy?.level || 1;
    this._setLevel();
  }

  private _setLevel() {
    const levelBackground = this._scene.add.rectangle(CARD_WIDTH/2 - 18, -CARD_HEIGHT/2 + 18, 18, 18, 0x0).setOrigin(0);
    const levelText = this._scene.add.text(CARD_WIDTH/2 - 9, -CARD_HEIGHT/2 + 27, this._level.toString(), {
      ...defaultText,
      strokeThickness: 0,
      fontSize: '10px',
    }).setOrigin(0.5);

    this._enemy.container.add([levelBackground, levelText]);
  }
}